import { render, staticRenderFns } from "./ReviewItem.vue?vue&type=template&id=62f5a38a&scoped=true"
import script from "./ReviewItem.vue?vue&type=script&lang=js"
export * from "./ReviewItem.vue?vue&type=script&lang=js"
import style0 from "./ReviewItem.vue?vue&type=style&index=0&id=62f5a38a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f5a38a",
  null
  
)

export default component.exports